export default __webpack_public_path__ + "static/media/home_3.394c6549.png";